import { AbsentReasonEnum } from "../enums/workflow.enums";

export const AbsentReasons = [
  { value: AbsentReasonEnum.SICK_CHILD, name: "Enfant malade" },
  { value: AbsentReasonEnum.PAID_LEAVE, name: "Congés payés" },
  { value: AbsentReasonEnum.SCHEDULE_CHANGE, name: "Changement de planning" },
  { value: AbsentReasonEnum.SICK, name: "Maladie" },
  { value: AbsentReasonEnum.TRAINER_EXCLUSION, name: "Exclusion formateur" },
  { value: AbsentReasonEnum.COMPANY_DEPARTURE, name: "Départ société" },
  { value: AbsentReasonEnum.ORGANIZATION_CANCELLATION, name: "Annulation par l'organisme" },
  { value: AbsentReasonEnum.HR_CANCELLATION, name: "Annulation par l'équipe RH" },
  { value: AbsentReasonEnum.ABANDONMENT, name: "Abandon" },
  { value: AbsentReasonEnum.UNJUSTIFIED, name: "Non justifié" },
  { value: AbsentReasonEnum.OTHER, name: "Autre" },
];
